<template>
    <tr v-if="freeSpace">
        <slot></slot>
    </tr>
    <tr
        v-else
        class="table-row"
        :class="
            `${breakpoint} ${mobileStriped && striped ? 'striped' : ''} ${
                bottomRounded ? 'bottom-rounded' : ''
            } ${noPadding ? 'p-0' : 'p-2 px-3'} ${
                expandable ? 'expandable' : ''
            } ${expanded ? 'expanded' : ''} ${
                childExpanded ? 'child-expanded' : ''
            } ${trSpacing ? 'tr-spacing' : ''} ${
                expandableContainer ? 'expandable-container' : ''
            } `
        "
    >
        <slot></slot>
    </tr>
</template>
<script>
export default {
    props: {
        breakpoint: {
            type: String,
            default: 'md'
        },
        mobileStriped: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bottomRounded: {
            type: Boolean,
            default: false
        },
        freeSpace: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        expandable: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: false
        },
        childExpanded: {
            type: Boolean,
            default: false
        },
        expandableContainer: {
            type: Boolean,
            default: false
        },
        trSpacing: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss">
@import '../../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

@mixin tableRowMixin($breakpoint) {
    @include media-breakpoint-up($breakpoint) {
        display: table-row;
        background-color: inherit;

        &:first-child,
        &:last-child {
            border-bottom: 1px solid rgba(0, 0, 0, 0);
        }
    }
}
.ui-data-table {
    .table-row {
        display: block;
        width: 100%;
        &:last-child {
            border-bottom: none;
        }
        &.striped {
            background-color: var(--color-gray-100);
        }
        border: 1px solid var(--color-gray-300);
        border-bottom: 1px solid var(--color-gray-200);
        border-top: none;
        &:first-of-type {
            border-top: 1px solid var(--color-gray-300);
            border-top-left-radius: 0.2rem;
            border-top-right-radius: 0.2rem;
        }
        &:last-of-type {
            &:not(.expandable) {
                border-bottom-left-radius: 0.2rem;
                border-bottom-right-radius: 0.2rem;
                border-bottom: 1px solid var(--color-gray-300);
            }
            & > td {
                &:first-of-type {
                    border-bottom-left-radius: 0.2rem;
                }
                &:last-of-type {
                    border-bottom-right-radius: 0.2rem;
                }
            }
        }

        &.md {
            @include tableRowMixin(md);
        }
        &.lg {
            @include tableRowMixin(lg);
        }
        &.child-expanded {
            td.all-borders {
                &:first-of-type {
                    border-bottom-left-radius: 0;
                }
                &:last-of-type {
                    border-bottom-right-radius: 0;
                }
            }
        }
        &.tr-spacing:not(.expandable):not(.child-expanded) {
            border-bottom: 1px solid var(--color-gray-300);
            border-top: 1px solid var(--color-gray-300);
            border-radius: 0.2rem;
        }
        &.expandable.expanded {
            border-bottom: 1px solid var(--color-gray-300);
            border-bottom-left-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;
            & > td {
                border-bottom-left-radius: 0.2rem;
                border-bottom-right-radius: 0.2rem;
            }
        }
    }
}
</style>
